"use strict";

angular.module('PatientApp').factory('PaymentsService', function (Models, VuexStore) {
  var calculateInstallmentAmount = function calculateInstallmentAmount(amount, installmentCount) {
    return Math.ceil(amount * 100 / installmentCount) / 100;
  };

  return {
    createPayment: function createPayment() {
      // I hate injecting the store into a model. This will be cleaned up later once migration is complete
      return new Models.Payment(VuexStore);
    },
    isPayment: function isPayment(payment) {
      return payment instanceof Models.Payment;
    },
    fetchPaymentDetails: function fetchPaymentDetails(paymentId) {
      return VuexStore.dispatch('fetchPaymentDetails', paymentId);
    },
    cancelPayment: function cancelPayment(paymentId) {
      return VuexStore.dispatch('cancelPayment', paymentId);
    },
    calculateInstallmentAmt: function calculateInstallmentAmt(amount, installmentCount) {
      return calculateInstallmentAmount(amount, installmentCount);
    },
    fetchPaymentAgreementDetails: function fetchPaymentAgreementDetails(paymentAgreementId) {
      return VuexStore.dispatch('fetchPaymentAgreementDetails', paymentAgreementId);
    },
    // static field to compare against the available states for a given payment
    paymentStates: {
      UNCONFIRMED: 'UNCONFIRMED',
      ABANDONED: 'ABANDONED',
      CANCELLED: 'CANCELLED',
      SCHEDULED: 'SCHEDULED',
      HELD: 'HELD',
      DECLINED: 'DECLINED',
      REPROCESSED: 'REPROCESSED',
      PROCESSED: 'PROCESSED',
      VOIDED: 'VOIDED',
      UNDISBURSED: 'UNDISBURSED',
      DISBURSED: 'DISBURSED',
      UNKNOWN: 'UNKNOWN'
    },
    reversalReasons: {
      REFUND: 'REFUND',
      CHARGEBACK: 'CHARGEBACK',
      FAILED_ECHECK: 'FAILED_ECHECK',
      BOUNCED_CHECK: 'BOUNCED_CHECK'
    }
  };
});